import React, {Component} from 'react';
import {connect} from "react-redux";
import logicGraphDataActions from "../../../actions/logicGraphDataActions";
import Predicate from "./Predicate";
import defaultPredicateOption from "./Predicate/const/switch/defaultSwitchPredicateOption";

import MaterialIcon from '../../MaterialIcon';
import uniqueId from 'lodash/uniqueId';
import {ReactSortable} from 'react-sortablejs';

import {removePort, addPort, editButton} from './InputPortListUtils/InputPortUtils';

const switchDefaultPredicateOption = defaultPredicateOption;

class InputPortList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            portList: [],
            options: {
                inputPortData: [],
                logDecisionName: null,
            },
            predicate: {
                type: "and",
                predicates: [
                    switchDefaultPredicateOption
                ]
            },

        };
        this.createList = this.createList.bind(this);
        this.createOption = this.createOption.bind(this);
        this.removePort = this.removePort.bind(this);
        this.addPort = this.addPort.bind(this);
        this.editButton = this.editButton.bind(this);
        this.inputHandle = this.inputHandle.bind(this);
        this.onOptionsUpdate = this.onOptionsUpdate.bind(this);
    }

    componentDidMount(){
        this.createList();
    }

    onOptionsUpdate(type, value, portID) {
        const portList = Object.values(Object.assign({}, this.state.portList));
        const portIndex = portList.map(port => { return port.id; }).indexOf(portID);
        portList[portIndex].predicate = value;
        this.setState({
            portList: portList
        }, () => this.createOption());
    }

    createList(){
        const engine = this.props.logicDataInfo
        const model = engine.getModel();
        const logicData = model.serialize();
        
        const clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
        const portList = [];
        const inputPortData = clickedNodeInfo.extras.options.inputPortData;


        Object.values(clickedNodeInfo.ports).forEach((v,i) => {
            const predicate = JSON.parse(JSON.stringify(this.state.predicate));
            const values = {
                logDecisionValue: '',
                predicate: predicate
            };

            if(typeof inputPortData !== 'undefined' && inputPortData.length > 0 && v.options.in){
                values.logDecisionValue = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].logDecisionValue : '';
                values.predicate = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].predicate : predicate;
            }

            const createData = {
                parentID: clickedNodeInfo.options.id,
                id: v.options.id,
                nodeName: 'Empty Input',
                branchName: '',
                index: 0,
                edit: false,
                sectionType: 'empty',
                logDecisionValue: values.logDecisionValue,
                predicate: values.predicate,
                in: v.options.in
            }

            if(v.connection){
                let nodeID = '';
                Object.values(logicData.layers.filter(layer => layer.type === 'diagram-links')[0].models).forEach(link => {
                    if(link.sourcePort === v.options.id){
                        nodeID = link.target;
                    }
                    if(link.targetPort === v.options.id){
                        nodeID = link.source;
                    }   
                });
                const nodeData = Object.values(logicData.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).filter(node => node.id === nodeID)[0];
                createData.nodeName = nodeData.name;
                createData.sectionType = nodeData.sectionType;
                createData.index = i
                portList.push(createData);
            }else {
                createData.index = i;
                portList.push(createData);
            }
        });

        const newPortList = [];
        const inputPortList = portList.filter(port => port.in);
        const outputPortList = portList.filter(port => port.in === false);
        inputPortList.forEach((v,i) => {
            v.index = i;
            newPortList.push(v);
        });
        outputPortList.forEach((v) => {
            newPortList.push(v);
        });
        
        this.setState(
            { portList: newPortList },
            () => this.createOption()
        );
    }

    createOption(){
        const inputPortData = [];
        const portList = Object.values(Object.assign({}, this.state.portList));

        const inputPortList = portList.filter(port => port.in);
        inputPortList.forEach(v => {
            inputPortData.push({
                logDecisionValue: v.logDecisionValue,
                predicate: v.predicate
            });
        });

        const options = Object.assign({}, this.state.options);
        options.inputPortData = inputPortData;
        options.logDecisionName = this.props.clickedNodeInfo.extras.options.logDecisionName;

        const logicGraphData = {
            options: options,
            portList: portList,
            id: this.props.clickedNodeInfo.options.id
        }
        this.props.logicGraphDataActions(logicGraphData);
    }
    
    removePort(item){
        const portList = removePort(this.state.portList,item);
        this.setState({
            portList: portList
        }, () => this.createOption());
        
    }
    addPort(){
        const portList = addPort(this.state, this.props.clickedNodeInfo.options.id, 'switch');
        this.setState({
            portList: portList
        }, () => this.createOption());
    }
    
    editButton(item){
        const setEditValue = editButton(this.state.portList, item);
        this.setState({
            portList: setEditValue
        });
    }

    inputHandle(event,item, name){
        let process = false;
        const portList = Object.assign({}, this.state.portList);
        const setInputData = Object.values(portList).map((v) => {
            if(v.id === item.id){
                if(name === 'logDecisionValue' && v.logDecisionValue !== event.target.value){
                    v.logDecisionValue = event.target.value;
                    process = true;
                }
            }
            return v;
        });
        if(process){
            this.setState({
                portList: setInputData
            }, () => this.createOption());
        }
    }

    render(){
        const defaultPort = (data) => {
            if (data.length === 0) return [];
            const minPortCount = 2;
            const portList = this.state.portList;
            const outputCount = portList.filter(port => !port.in).length;
            const inputPortListCount = portList.length - outputCount;

            const firstPort = portList[0].id;
            let lastPort = portList[inputPortListCount - 1].id;
            let hiddenPortID = '';

            if(inputPortListCount > minPortCount){
                hiddenPortID = lastPort;
                lastPort = portList[inputPortListCount - 2].id;
            }
          
            return data.map((val) => {
                const hiddenClassName = hiddenPortID === val.id ? 'hidden' : '';
                return (
                    <div className={`input-area ${val.sectionType} ${hiddenClassName}`} data-id={val.id} key={val.id}>
                        <div className="input-container">
                            <div className="input">
                                <div className="input-name">
                                    <span className="name">{val.nodeName}</span>
                                    <span className="input-index">{val.index}</span>
                                </div>
                                <div className="drag-handle">
                                    <MaterialIcon icon="drag_indicator" size={24}/>
                                </div>
                                <div className="input-editor">
                                    <span className="input-editor-name">{val.id === lastPort ? 'Else' : (val.id === firstPort ? 'If' : 'Else If')}</span>
                                    <input className="panel-input" onBlur={(event) => this.inputHandle(event, val, 'logDecisionValue')} defaultValue={val.logDecisionValue} type="text" placeholder="Condition Name"/>
                                </div>
                                <div className="action-area">
                                    {
                                        val.id !== lastPort &&
                                        <button className={`edit-button ${val.edit ? 'active' : ''}`} onClick={()=> this.editButton(val)}>Edit<MaterialIcon icon="keyboard_arrow_down" size={24}/></button>
                                    }
                                    {
                                        inputPortListCount > 3 &&
                                        <button className="remove-button round" onClick={() => this.removePort(val)}><MaterialIcon icon="close"/></button>
                                    }
                                </div>
                            </div>
                            {
                                val.id !== lastPort &&
                                <div className={`input-dropdown ${val.edit ? 'active' : ''}`}>
                                    <Predicate updateOptions={(predicate) => this.onOptionsUpdate("predicate", predicate, val.id)} predicate={val.predicate} hasInputCount predicateBlockType={"switch"}/>
                                </div>
                            }
                            
                        </div>
                    </div>
                )
            })
        }
        const groupCreate = () => {
            const portListData = this.state.portList.filter(port => port.in);
            
            const roundRobin = portListData.filter(port => port.roundRobin).length > 0 ? 'round-robin' : '';
            return (
                <ReactSortable key = "static"
                    animation = {150}
                    handle = '.drag-handle'
                    group = {'default_group' + uniqueId()}
                    pull = {true}
                    put = {true}

                    list={portListData}
                    setList = {(newState)=> {
                        if (portListData.length !== newState.length || !portListData.every((val, index) => val === newState[index])) {
                            const newPortList = [...newState];
                            newPortList.forEach((val,key) => {
                                val.index = key;
                                return val;
                            });
                            const outputPortList = this.state.portList.filter(port => port.in === false);
                            outputPortList.forEach((v) => {
                                newPortList.push(v);
                            });
                            
                            this.setState(
                                { portList: newPortList },
                                () => this.createOption()
                            );
                        }
                    }}
                    className={`list-area ${roundRobin} group-${portListData.length ? portListData[0].groupID : ''}`}
                >
                    {defaultPort(portListData)}
                </ReactSortable>
            )

        }
        return (
            <div className="node-input-list">
                {
                    this.state.portList && groupCreate()
                }
                <div className="bottom-button-area">
                    <button className="add-button" onClick={this.addPort}><MaterialIcon icon="add_circle"/>Add Input</button>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
        logicDataInfo: state.logicDataInfo,
        logicGraphData: state.logicGraphData
    }
}
export default connect(mapStateToProps, {logicGraphDataActions})(InputPortList);
